import { BrowserRouter } from 'react-router-dom';
import { useAuth } from './components/auth/AuthProvider';
import Breadcrumbs from './components/Common/BreadCrumbs.component';
import Navbar from './components/Navbar/Navbar.component';
import Routes from './components/Routes.component';
import Spinner from './components/Spinner.component';
import ActionModal from './hooks/ActionModal.hook';
import Me from './hooks/Me.hook';


function App() {
  const {
    isLoading,
    isAuthenticated,
  } = useAuth();

  if (isLoading) {
    return <Spinner />;
  }

  if (isAuthenticated) {
    return (
      <Me>
        <ActionModal>
          <BrowserRouter>
            <Navbar />
            <Breadcrumbs/>
            <Routes />
          </BrowserRouter>
        </ActionModal>
      </Me>
    );
  } else {
    return (
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    );
  }
}
export default App;